import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, ClipboardList, BookOpen, Users, Settings, Rocket, LogOut, Menu, X, HardHat, FileText, Building2 } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "../lib/auth";

const NAV = {
  admin: [["/admin", "Dashboard", LayoutDashboard], ["/admin/inspections", "Inspections", ClipboardList], ["/admin/library", "Defect Library", BookOpen],
    ["/admin/users", "People & Builders", Users], ["/admin/settings", "Settings & Checklist", Settings], ["/admin/roadmap", "Roadmap", Rocket]],
  inspector: [["/inspector", "My Inspections", HardHat], ["/inspector/new", "New Property", ClipboardList]],
  customer: [["/customer", "My Reports", FileText]],
  builder: [["/builder", "Rectification Portal", Building2]],
};

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const items = NAV[user.role] || [];
  const out = () => { logout(); nav("/"); };
  const Links = () => items.map(([to, label, Icon]) => (
    <NavLink key={to} to={to} end onClick={() => setOpen(false)} data-testid={`nav-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
      className={({ isActive }) => `tap flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium ${isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"}`}>
      <Icon className="h-4 w-4" /> {label}
    </NavLink>
  ));
  const sidebar = user.role === "admin";
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/85 backdrop-blur-md">
        <div className="mx-auto flex h-14 max-w-[1500px] items-center justify-between px-4">
          <div className="flex items-center gap-3">
            {sidebar && <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="mobile-nav-toggle">{open ? <X /> : <Menu />}</button>}
            <NavLink to="/" data-testid="header-home-link"><Logo /></NavLink>
          </div>
          {!sidebar && <nav className="hidden items-center gap-1 md:flex"><Links /></nav>}
          <div className="flex items-center gap-3">
            <div className="hidden text-right sm:block">
              <div className="text-sm font-semibold leading-tight" data-testid="header-user-name">{user.name}</div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{user.role}</div>
            </div>
            <button onClick={out} className="tap rounded-md border border-slate-200 p-2 text-slate-600 hover:bg-slate-100" data-testid="logout-button" title="Sign out"><LogOut className="h-4 w-4" /></button>
          </div>
        </div>
        {!sidebar && items.length > 1 && <nav className="flex gap-1 overflow-x-auto border-t border-slate-100 px-3 py-1.5 md:hidden"><Links /></nav>}
      </header>
      <div className="mx-auto flex max-w-[1500px]">
        {sidebar && (
          <aside className={`${open ? "fixed inset-0 top-14 z-20 block bg-white p-4" : "hidden"} lg:sticky lg:top-14 lg:block lg:h-[calc(100vh-3.5rem)] lg:w-64 lg:shrink-0 lg:border-r lg:border-slate-200 lg:bg-white lg:p-4`}>
            <div className="space-y-1"><Links /></div>
            <div className="mt-8 rounded-lg border border-dashed border-slate-300 p-3 text-xs text-slate-500">
              <div className="overline mb-1 text-[10px]">Bangalore · Phase 1</div>
              Multi-city expansion is on the roadmap.
            </div>
          </aside>
        )}
        <main className="min-w-0 flex-1 px-4 py-6 sm:px-6 lg:px-8">{children}</main>
      </div>
    </div>
  );
}
